import { action, computed, makeObservable, observable } from "mobx";
import toast from "react-hot-toast";
import URLConstants from "../../constants/url-constants";
import { IObservableInitialState } from "../../models/ICommon";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { formatMessage } from "../../translations/format-message";

import {
  IAddHeadquarter,
  IHeadquarterListVM,
  IHeadquarterVM,
  ITemplateVM,
  IHeadquarterCancelationPolicy,
  IUpdateHeadquarter,
  IUpdateHeadquarterTemplate,
  IUpdateHeadquarterCancelationPolicy,
  IUpdateHeadquarterUploadIcons,
} from "../../models/response/IHeadquarterResponse";
import {
  AddHeadquarterState,
  AddUpdateHeadquarterTemplateState,
  AddUpdateHeadquarterCancelationPolicyState,
  HeadquarterInitialState,
} from "../initialState/add-edit-headquarter-state";
import * as baseService from "../service/base-service";
import { headquarterInitialFilterState } from "../initialState/initial-filter-state";
import { IHeadquarterFilter } from "../../models/IFilter";

export class HeadquarterStore {
  initialStateValue: IObservableInitialState = {
    success: false,
    error: "",
    inProgress: false,
  };

  headquarter: IHeadquarterVM = AddHeadquarterState;
  headquarterList: IHeadquarterListVM = HeadquarterInitialState;
  addUpdateHeadquartertState = { ...this.initialStateValue };
  getAllHeadquartertListState = { ...this.initialStateValue };
  getHeadquartertByIdState = { ...this.initialStateValue };
  deleteHeadquarterByIdState = { ...this.initialStateValue };
  
  headquarterFilter: IHeadquarterFilter = { ...headquarterInitialFilterState };
  headquarterTemplatesState = { ...this.initialStateValue };
  headquarterTemplates: ITemplateVM | undefined = undefined;

  hqCancelationPolicy: IHeadquarterCancelationPolicy | undefined = undefined;
  hqCancellationPolicyDetailsState = { ...this.initialStateValue };
  addUpdateHeadquarterCancelationPolicyState = { ...this.initialStateValue };

  addUpdateHeadquarterTemplateState = { ...this.initialStateValue };
  addUpdateHeadquarterUploadIconsState = { ...this.initialStateValue };
  disableAction:boolean = false;


  constructor() {
    makeObservable(this, {
      initialStateValue: observable,
      headquarter: observable,
      headquarterList: observable,
      addUpdateHeadquartertState: observable,
      getAllHeadquartertListState: observable,
      getHeadquartertByIdState: observable,
      deleteHeadquarterByIdState: observable,
      headquarterFilter: observable,
      headquarterTemplates: observable,
      headquarterTemplatesState: observable,
      hqCancellationPolicyDetailsState: observable,
      hqCancelationPolicy: observable,
      addUpdateHeadquarterCancelationPolicyState: observable,
      addUpdateHeadquarterTemplateState: observable,
      addUpdateHeadquarterUploadIconsState: observable,
      disableAction: observable,
      GetAllHeadquarterListService: action,
      GetHeadquarterTemplatesByIdService: action,
      GetHeadquarterCancelationDetail: action,
      AddHeadquarterService: action,
      UpdateHeadquarterService: action,
      UpdateHeadquarterTemplateService: action,
      UpdateHeadquarterUploadIconsService: action,
      UpdateCancelationHeadquarterService: action,
      GetHeadquarterCancelationBookingStoreDetail: action,
      GetHeadquarterIconsByIdService: action,
      DeleteHeadquarterService: action,
      resetHeadquarterList: action,
      resetAddUpdateHeadquarter: action,
      resetGetHeadquarterDetail: action,
      resetHeadquarterTemplatesState: action,
      resetAddUpdateHeadquarterTemplateState: action,
      resetAddUpdateHeadquarterUploadIconsState: action,
      resetAddUpdateHeadquarterCancelation: action,
      resetGetHeadquarterCancelationDetail: action,
      resetDeleteHeadquarter: action,
      setHeadquarterFilterDetail: action,
      resetHeadquarterFilterDetail: action,
      setDisableAction: action,
      getHeadquarterFilter: computed,
      headquarterDetails: computed,
      headquarterTemplateDetails: computed,
      headquarterIcons: computed,
      allHeadquarterList: computed,
      headquarterCancelationPolicyDetails: computed,
      getHeadquarterCancelationPolicyForReservationDetails: computed,
    });
  }

  GetAllHeadquarterListService = (
    currentPage: number,
    pagerSize: number,
    businessTypeId: number
  ) => {
    this.getAllHeadquartertListState.inProgress = true;
    const url =
      URLConstants.GetHeadquarterByBusinessTypeId +
      "?PageNo=" +
      currentPage +
      "&PageSize=" +
      pagerSize +
      "&businessTypeId=" +
      businessTypeId;
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IHeadquarterListVM>>) => {
          if (response.data.Error) {
            this.getAllHeadquartertListState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.headquarterList = response.data.Data;
          }
        }
      )
      .catch((err: string) => {
        this.getAllHeadquartertListState.error = err;
      })
      .finally(
        action(() => {
          this.getAllHeadquartertListState.inProgress = false;
        })
      );
  };

  AddHeadquarterService = (data: IAddHeadquarter) => {
    this.addUpdateHeadquartertState.inProgress = true;
    let url = URLConstants.AddHeaquarter;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateHeadquartertState.error = response.data.Message;
        } else this.addUpdateHeadquartertState.success = true;
      })
      .catch((err: string) => {
        this.addUpdateHeadquartertState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateHeadquartertState.inProgress = false;
        })
      );
  };

  UpdateHeadquarterService = (data: IUpdateHeadquarter) => {
    this.addUpdateHeadquartertState.inProgress = true;
    let url = URLConstants.UpdateHeaquarter;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateHeadquartertState.error = response.data.Message;
        } else this.addUpdateHeadquartertState.success = true;
      })
      .catch((err: string) => {
        this.addUpdateHeadquartertState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateHeadquartertState.inProgress = false;
        })
      );
  };
  UpdateHeadquarterTemplateService = (data: IUpdateHeadquarterTemplate) => {
    this.addUpdateHeadquarterTemplateState.inProgress = true;
    let url = URLConstants.UpdateHeadquarterTemplateImages;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateHeadquarterTemplateState.error = response.data.Message;
        } else this.addUpdateHeadquarterTemplateState.success = true;
      })
      .catch((err: string) => {
        this.addUpdateHeadquarterTemplateState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateHeadquarterTemplateState.inProgress = false;
        })
      );
  };

  resetAddUpdateHeadquarterTemplateState = () =>{
    this.addUpdateHeadquarterTemplateState = {...this.initialStateValue};
  }
  
  UpdateHeadquarterUploadIconsService = (data: IUpdateHeadquarterUploadIcons) => {
    this.addUpdateHeadquarterUploadIconsState.inProgress = true;
    let url = URLConstants.UpdateHeadquarterIcons;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateHeadquarterUploadIconsState.error = response.data.Message;
        } else this.addUpdateHeadquarterUploadIconsState.success = true;
      })
      .catch((err: string) => {
        this.addUpdateHeadquarterUploadIconsState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateHeadquarterUploadIconsState.inProgress = false;
        })
      );
  };

  resetAddUpdateHeadquarterUploadIconsState = () =>{
    this.addUpdateHeadquarterUploadIconsState = {...this.initialStateValue};
  }


    UpdateCancelationHeadquarterService = (data: IUpdateHeadquarterCancelationPolicy) => {
    this.addUpdateHeadquarterCancelationPolicyState.inProgress = true;
    let url = URLConstants.GetHeadquarterCancelationPolicyById;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateHeadquarterCancelationPolicyState.error = response.data.Message;
        } else this.addUpdateHeadquarterCancelationPolicyState.success = true;
      })
      .catch((err: string) => {
        this.addUpdateHeadquarterCancelationPolicyState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateHeadquarterCancelationPolicyState.inProgress = false;
        })
      );
  };


  GetHeadquarterByIdService = (id: number) => {
    this.getHeadquartertByIdState.inProgress = true;
    let url = `${URLConstants.GetHeadquarterById}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getHeadquartertByIdState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.headquarter = data;
        }
      })
      .catch((err: string) => {
        this.getHeadquartertByIdState.error = err;
      })
      .finally(
        action(() => {
          this.getHeadquartertByIdState.inProgress = false;
        })
      );
  };
  
  GetHeadquarterIconsByIdService = (id: number) => {
    this.getHeadquartertByIdState.inProgress = true;
    let url = `${URLConstants.GetHeadquarterById}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.disableAction = false;
          this.getHeadquartertByIdState.error = response.data.Message;
        } else {
          this.disableAction = false;
          let data = response.data.Data;
          this.headquarter = data;
        }
      })
      .catch((err: string) => {
        this.disableAction = true;
        toast.error(formatMessage(err));
        this.getHeadquartertByIdState.error = err;
      })
      .finally(
        action(() => {
          this.getHeadquartertByIdState.inProgress = false;
        })
      );
  };



  GetHeadquarterTemplatesByIdService = (id: number) => {
    this.headquarterTemplatesState.inProgress = true;
    let url = `${URLConstants.GetHeadquarterTemplatesById}/${id}/Templates`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.disableAction = false;
          this.headquarterTemplatesState.error = response.data.Message;
        } else {
          this.disableAction = false;
          let data = response.data.Data;
          this.headquarterTemplates = data;
        }
      })
      .catch((err: string) => {
        this.disableAction = true;
        toast.error(formatMessage(err));
        this.headquarterTemplatesState.error = err;
      })
      .finally(
        action(() => {
          this.headquarterTemplatesState.inProgress = false;
        })
      );
  };

  GetHeadquarterCancelationDetail = (id: number) => {
    this.hqCancellationPolicyDetailsState.inProgress = true;
    let url = `${URLConstants.GetHeadquarterCancelationPolicyById}?headquarterId=${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.hqCancellationPolicyDetailsState.error = response.data.Message;
          this.disableAction = false;
        } else {
          let data = response.data.Data;
          this.disableAction = false;
          this.hqCancelationPolicy = data;
        }
      })
      .catch((err: string) => {
        this.disableAction = true;
        toast.error(formatMessage(err));
        this.hqCancellationPolicyDetailsState.error = err;
      })
      .finally(
        action(() => {
          this.hqCancellationPolicyDetailsState.inProgress = false;
        })
      );
  };

    GetHeadquarterCancelationBookingStoreDetail = (storeId: number,headquarterId: any) => {
    this.hqCancellationPolicyDetailsState.inProgress = true;
    let url = `${URLConstants.GetHeadquarterCancelationPolicyById}?storeid=${storeId}&headquarterId=${headquarterId}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.hqCancellationPolicyDetailsState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.hqCancelationPolicy = data;
        }
      })
      .catch((err: string) => {
        this.hqCancellationPolicyDetailsState.error = err;
      })
      .finally(
        action(() => {
          this.hqCancellationPolicyDetailsState.inProgress = false;
        })
      );
  };

  DeleteHeadquarterService = (Id: number) => {
    this.deleteHeadquarterByIdState.inProgress = true;
    let url = `${URLConstants.DeleteHeadquarter}/${Id}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteHeadquarterByIdState.error = response.data.Message;
          // toast.error(formatMessage(response.data.Message));
        } else this.deleteHeadquarterByIdState.success = true;
      })
      .catch((err: string) => {
        this.deleteHeadquarterByIdState.error = err;
      })
      .finally(
        action(() => {
          this.deleteHeadquarterByIdState.inProgress = false;
        })
      );
  };

  /**
   * This function provides initail values to the get Headquarter Details.
   * @returns headquarter Details
   *
   */
  get headquarterDetails(): any {
    if (this.headquarter) {
      return {
        Id: this.headquarter.Id,
        HeadquarterName: this.headquarter.HeadquarterName,
        BusinessTypeId: this.headquarter.BusinessType.Id,
        Password: "",
        Email: this.headquarter.Email,
        ProductIcon: this.headquarter.ProductIcon,
        TreatmentIcon: this.headquarter.TreatmentIcon,
        ConfirmPassword: "",
      };
    }
    return AddHeadquarterState;
  }
  
  get headquarterTemplateDetails(): IUpdateHeadquarterTemplate {
    if (this.headquarter && this.headquarterTemplates) {
      return {
        Id: this.headquarter.Id,
        TemplateBeforeOne: this.headquarterTemplates.TemplateBeforeOne,
        TemplateBeforeTwo: this.headquarterTemplates.TemplateBeforeTwo,
        TemplateAfterOne: this.headquarterTemplates.TemplateAfterOne,
        TemplateAfterTwo: this.headquarterTemplates.TemplateAfterTwo,
      };
    }
    return AddUpdateHeadquarterTemplateState;
  }

  get headquarterCancelationPolicyDetails(): any {
    if (this.headquarter && this.hqCancelationPolicy) {
      return {
        Id: this.headquarter.Id,
        HeadquarterCancelationPolicy: this.hqCancelationPolicy.HeadquarterCancelationPolicy,
        HeadquarterCancelationText: this.hqCancelationPolicy.HeadquarterCancelationText,
        ShowOnFilter: this.hqCancelationPolicy.ShowOnFilter,
      };
    }
    return AddUpdateHeadquarterCancelationPolicyState;
  }
  
  get getHeadquarterCancelationPolicyForReservationDetails(): any {
    if (this.hqCancelationPolicy) {
      return {
        HeadquarterCancelationPolicy: this.hqCancelationPolicy.HeadquarterCancelationPolicy,
        HeadquarterCancelationText: this.hqCancelationPolicy.HeadquarterCancelationText,
        Precaution: this.hqCancelationPolicy.Precaution,
        ShowOnFilter: this.hqCancelationPolicy.ShowOnFilter,
      };
    }
    return AddUpdateHeadquarterCancelationPolicyState;
  }
  
  /**
   * This function provides initail values to the get Headquarter Details.
   * @returns headquarter icons
   *
   */
  get headquarterIcons(): any {
    if (this.headquarter) {
      return {
        Id: this.headquarter.Id,
        ProductIcon: this.headquarter.ProductIcon,
        TreatmentIcon: this.headquarter.TreatmentIcon,
      };
    }
    return AddHeadquarterState;
  }

  /**
   * This function is used to map headquarterList suitable for Grid Component.
   * @returns allHeadquarterList
   */
  get allHeadquarterList(): any[] {
    if (
      this.headquarterList?.HeadquarterList &&
      this.headquarterList.HeadquarterList?.length > 0
    )
      return this.headquarterList.HeadquarterList?.map((headquaterVM) => {
        let isDelete = true;
        let isEdit = true;

        return {
          Id: headquaterVM.Id,
          Email: headquaterVM.Email,
          HeadquarterName: headquaterVM.HeadquarterName,
          BusinessType: headquaterVM.BusinessType,
          ProductIcon: headquaterVM.ProductIcon,
          TreatmentIcon: headquaterVM.TreatmentIcon,
          isDelete: isDelete,
          isEdit: isEdit,
        };
      });
    return [];
  }

  resetHeadquarterList = () => {
    this.getAllHeadquartertListState = { ...this.initialStateValue };
  };

  resetAddUpdateHeadquarter = () => {
    this.addUpdateHeadquartertState = { ...this.initialStateValue };
  };

  resetGetHeadquarterDetail = () => {
    this.headquarter = AddHeadquarterState;
    this.getHeadquartertByIdState = { ...this.initialStateValue };
  };
  
  resetHeadquarterTemplatesState = () => {
    this.headquarterTemplates = undefined;
    this.headquarterTemplatesState = { ...this.initialStateValue };
  };

  resetAddUpdateHeadquarterCancelation = () => {
    this.addUpdateHeadquarterCancelationPolicyState = { ...this.initialStateValue };
  };

  resetGetHeadquarterCancelationDetail = () => {
    this.hqCancelationPolicy = undefined;
    this.hqCancellationPolicyDetailsState = { ...this.initialStateValue };
  };

  
  resetDeleteHeadquarter = () => {
    this.deleteHeadquarterByIdState = { ...this.initialStateValue };
  };

  setHeadquarterFilterDetail = (filter: IHeadquarterFilter) => {
    this.headquarterFilter = { ...filter };
  };

  resetHeadquarterFilterDetail = () => {
    this.headquarterFilter = { ...headquarterInitialFilterState };
  };

  get getHeadquarterFilter(): IHeadquarterFilter {
    return this.headquarterFilter;
  }

  setDisableAction = (acionStatus: boolean) =>{
    this.disableAction = acionStatus;
  }
}

export default new HeadquarterStore();
